import {
  extractYoutubeVideoId,
  isYouTube,
  youtubeShortsHack
} from "@input-output-hk/essential-cardano-utils";

export const generateInlineVideoUrl = (videoUrl: string): string => {
  try {
    const url = new URL(videoUrl);
    url.searchParams.set("__ec_inline", "1");
    return url.href;
  } catch (err) {
    console.error("malformed url: ", videoUrl, err);
    return videoUrl;
  }
};

export const maybeGetOriginalVideoUrl = (videoUrl: string): string | null => {
  try {
    const url = new URL(videoUrl);
    if (url.searchParams.get("__ec_inline") === "1") {
      url.searchParams.delete("__ec_inline");
      return youtubeShortsHack(url.href);
    }
  } catch (err) {
    console.warn("Ignoring malformed url: ", videoUrl, err);
  }

  return null;
};

export const videoSupportsInlining = (videoUrl: string): boolean => {
  return (
    isYouTube(videoUrl) && typeof extractYoutubeVideoId(videoUrl) === "string"
  );
};
